import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Compute extends Bloc {

	constructor (src, ctx, target) {

		super("compute", src, ctx, true);
		this.f = (src, ins) => [this];
		this.types = [Types.int, Types.value];
	}

	setup (owner, image) {

		let code = owner.computecode;
		let previousCompute = owner.compute ? owner.compute : (c => { return { type: null, value: 0 } })
		owner.compute = c => {
			if (code === undefined || code === null || c === code) {
				const type = this.in[1]();
				let value = this.in[0]();
				if (type === "overgrowth") {
					const manaPerTurn = 3 + owner.master.player.getStatusValue("photosynthesis") / 3;
					const efficiency = 1 + (owner.master.run.champion.getPassive("overgrowthbonus") || 0);
					value = Math.round(value / manaPerTurn * efficiency * 100);
				} else if (type === "heal") {
					if (!owner.recovery || owner.fullRecoveryActive)
						return { type: null, value: 0 };
					value = owner.recoveryAmount();
				} else if (type === "exp") {
					if (owner.corrupt && !owner.fullCorruptActive)
						value = 0;
				}
				return { type, value };
			}
			return previousCompute(c);
		}
	}
}
